module.exports = __webpack_public_path__ + "media/images/braintree-logo-icon-027565004f5ac061585f57ca21468c45.svg";